export const SCRIPT_SIZE_LIMIT = 5 * 1024 * 1024; // 5Mb
export const CHARACTER_LIMIT = 5 * 1024 * 1024;
